import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Name-Arcane/src/components/category/CategoryHubClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/Name-Arcane/src/components/seo/FaqSection.tsx");
